import React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import type { RadioGroupProps } from "@mui/material/RadioGroup";

import { RadioOptions } from ".";

interface IRadioInput extends RadioGroupProps {
  label: React.ReactNode;
  options: RadioOptions[];
  disabled?: boolean;
  errorText?: string | boolean | undefined;
  containerStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
}

function RadioInputComponent({
  label,
  options,
  disabled,
  errorText,
  className,
  containerStyle,
  labelStyle,
  sx,
  ...rest
}: IRadioInput) {
  return (
    <FormControl component="fieldset" sx={{ ...sx }}>
      <FormLabel
        component="legend"
        id="demo-controlled-radio-buttons-group"
        sx={{
          color: "#1F4970",
          margin: "10px 2px",
          top: "8px",
          "& .MuiSelect-select.Mui-disabled": {
            WebkitTextFillColor: "#000000 !important",
            color: "#000000 !important",
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#000000 !important",
            color: "#000000 !important",
          },
          fontSize: "16px!important",
          fontWeight: "600!important",
          textTransform: "capitalize",
          ...labelStyle,
        }}
      >
        {label}
      </FormLabel>
      <RadioGroup
        row
        aria-label="position"
        name="position"
        aria-labelledby="demo-controlled-radio-buttons-group"
        sx={{ width: "100%", ...sx }}
        {...rest}
      >
        <Box
          sx={{
            padding: "3px 0",
            margin: "10px 0px 0px 0px",
            width: "100%",
            display: "flex",
            gap: "12px",
            flexWrap: "wrap",
            flexDirection: "row",
            justifyContent: "flex-start",
            ...containerStyle,
          }}
        >
          {options.map((option) => (
            <FormControlLabel
              sx={[
                {
                  justifyContent: "flex-start",
                  alignItems: "center",
                  padding: "4px 16px 4px 8px",
                  borderRadius: "15px",
                  display: "flex",
                  margin: "0px 0px 3px 0px",
                  "& .MuiSelect-select.Mui-disabled": {
                    WebkitTextFillColor: "#000000 !important",
                    color: "#000000 !important",
                  },
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "#000000 !important",
                    color: "#000000 !important",
                  },
                  flex: "0 0 auto",
                  whiteSpace: "nowrap",
                  "& .MuiFormControlLabel-label": {
                    fontSize: "14px",
                    fontWeight: "500",
                    paddingLeft: "8px",
                  },
                  fontSize: "14px",
                  fontWeight: "400",
                },
                errorText
                  ? {
                      border: "1px solid #ff1818",
                    }
                  : {
                      border: "1px solid #ccc",
                    },
                errorText
                  ? {
                      color: "#ff1818",
                    }
                  : {
                      color: "#1F4970",
                    },
              ]}
              labelPlacement="end"
              label={option.label}
              className={className}
              value={option.value}
              control={
                <Radio
                  style={{
                    color: errorText
                      ? "#ff1818"
                      : disabled
                        ? "rgb(154, 154, 154)"
                        : "#1F4970",
                  }}
                />
              }
              key={option.value}
              disabled={disabled}
            />
          ))}
        </Box>
        {errorText && <FormHelperText error>{errorText}</FormHelperText>}
      </RadioGroup>
    </FormControl>
  );
}

export default RadioInputComponent;
